var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArbusdt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#213147;}\n\t.st1{fill:#12AAFF;}\n\t.st2{fill:#9DCCED;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.3,152V348c0,12.5,6.6,24,17.5,30.3l169.8,98c10.8,6.2,24.1,6.2,35,0l169.8-98 c10.8-6.2,17.5-17.8,17.5-30.3V152c0-12.5-6.6-24-17.5-30.3l-169.8-98c-10.8-6.2-24.1-6.2-35,0l-169.8,98 C52,127.9,45.3,139.5,45.3,152z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.1,288l-24.2,66.4c-0.7,1.8-0.7,3.9,0,5.7l41.6,114.2l48.2-27.8L294.9,288 C293.6,284.3,288.5,284.3,287.1,288z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335.6,176.3c-1.3-3.7-6.4-3.7-7.8,0l-24.2,66.4c-0.7,1.8-0.7,3.9,0,5.7l68.2,187.1l48.2-27.8L335.6,176.3z "
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M250,31c1.2,0,2.4,0.3,3.5,0.9L437.2,138c2.1,1.2,3.5,3.5,3.5,5.9V356c0,2.5-1.3,4.7-3.5,5.9L253.5,468.1 c-1,0.6-2.2,0.9-3.5,0.9s-2.4-0.3-3.5-0.9L62.9,362c-2.1-1.2-3.5-3.5-3.5-5.9V143.9c0-2.5,1.3-4.7,3.5-5.9L246.6,31.9 C247.6,31.3,248.9,31,250,31 M250,0c-6.5,0-13.1,1.7-18.9,5.1L47.4,111.2c-11.7,6.7-18.9,19.2-18.9,32.7V356 c0,13.5,7.3,26.1,18.9,32.8l183.7,106.1c5.8,3.4,12.4,5.1,18.9,5.1c6.5,0,13.1-1.7,18.9-5.1l183.7-106.1 c11.8-6.7,18.9-19.2,18.9-32.8V143.9c0-13.5-7.3-26.1-18.9-32.8L269,5.1C263.1,1.7,256.5,0,250,0L250,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "128.6,435.7 145.5,389.4 179.4,417.7 147.7,446.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M234.6,128.8H188c-3.5,0-6.6,2.1-7.8,5.4L80.4,407.9l48.2,27.8l109.9-301.4 C239.5,131.6,237.5,128.8,234.6,128.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M316.1,128.8h-46.5c-3.5,0-6.6,2.1-7.8,5.4l-114,312.5l48.2,27.8L320,134.4 C321,131.6,318.9,128.8,316.1,128.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbusdt);
export default __webpack_public_path__ + "static/media/arbusdt.e2a120dcffb5e152fd7ce7a9001915e2.svg";
export { ForwardRef as ReactComponent };